import React, { useState, useEffect } from "react";
import "./App.css";
import "./tailwind.output.css";
import ResumeForm from "./ResumeForm";
import Header from "./Header";

function App() {
  const [accessToken, setAccessToken] = useState("");
  useEffect(() => {
    // Check to see if this is a redirect back from Checkout
    const query = new URLSearchParams(window.location.search);
      if (query.get("success")) {
        alert("Purchase success, please check your email to get your access token")
      }

      if (query.get("canceled")) {
        alert("Purchase session cancelled")
      }
  
  }, []); 

  return (
    <div className="App min-h-screen transition-all">
      <Header accessToken={accessToken} onInputChange={setAccessToken}/>
      <main className="container mx-auto min-h-screen">
        <ResumeForm accessToken={accessToken} />
         
      </main>
      
<footer className="footer p-10 bg-neutral text-neutral-content mt-24">
  <div>
    <h1 className="font-bold">Xyd.<br/>Dev For Fun</h1>
    <p>Copyright © 2023 - All right reserved</p>
  </div> 
  <div>
    <div className="grid grid-flow-col gap-4">
    <b>Support Email:<br/>devyu0217.techhelp@outlook.com</b>
      </div>
  </div>
</footer>
    </div>
    
  );
}

export default App;